module.exports = __webpack_public_path__ + "img/744.12fa31fd.jpg";